module.exports = __webpack_public_path__ + "static/media/my-business-step.e0015ff4.png";